import { ReactNode } from 'react';
import { renderers } from './renderers';
import { MarkdownRenderContext } from '../../../ui';

interface IMarkdownRenderContextProviderProps {
	children: ReactNode;
}

export function MarkdownRenderContextProvider({
	children,
}: IMarkdownRenderContextProviderProps) {
	return (
		<MarkdownRenderContext.Provider value={renderers}>
			{children}
		</MarkdownRenderContext.Provider>
	);
}
